import { render } from "./SideMenuPagination.vue?vue&type=template&id=fe542a7c"
import script from "./SideMenuPagination.vue?vue&type=script&lang=js"
export * from "./SideMenuPagination.vue?vue&type=script&lang=js"

import "./SideMenuPagination.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__